import React from 'react'
import EditIcon from '@mui/icons-material/Edit'
import InputBox from '../../../../atomic/inputbox/InputBox'
import SelectBox from '../../../../atomic/selectbox/SelectBox'
import { servingTemperatureList } from '../constants'
import { SectionCard } from './SectionCard'
import { EditableField } from './EditableField'
import styles from './styles.module.css'

export const PricingSection = ({
  price,
  quantity, setQuantity,
  servingTemperature, setServingTemperature,
  errors,
  editingFields,
  startEdit,
  cancelField,
  onChangeHandler,
  trackField
}) => {
  // Price is always read-only; only quantity and serving temperature are editable in this section.
  const pricingKeys = ['available_quantity', 'serving_temperature']
  const isPricingEditing = pricingKeys.some(key => !!editingFields[key])

  const startPricingEdit = () => {
    pricingKeys.forEach(key => startEdit(key))
  }

  const cancelPricingEdit = () => {
    cancelField('available_quantity', setQuantity)
    cancelField('serving_temperature', setServingTemperature)
  }

  return (
    <SectionCard
      title='Pricing & Availability'
      headerAction={(
        isPricingEditing ? (
          <button
            onClick={cancelPricingEdit}
            title='Cancel section editing'
            className={styles.sectionHeaderCancelBtn}
          >
            ✕
          </button>
        ) : (
          <button
            onClick={startPricingEdit}
            title='Edit Pricing & Availability'
            className={styles.sectionHeaderEditBtn}
          >
            <EditIcon sx={{ color: '#181436', fontSize: 18 }} />
          </button>
        )
      )}
    >
    <div className={styles.pricingRow}>

      <div className={styles.priceWrapper}>
        <EditableField
          label='Price'
          displayValue={price && price !== '0.00' ? `$${price}` : ''}
          isEditing={false}
          showActions={false}
        />
      </div>

      <div className={styles.quantityWrapper}>
        <EditableField
          label='Quantity'
          displayValue={quantity}
          isEditing={isPricingEditing}
          showActions={false}
        >
          <InputBox
            type='number'
            label='Quantity'
            size='small'
            sx={{ width: '100%', height: 'auto' }}
            name='quantity'
            value={quantity}
            error={!!errors.quantity || quantity === '' || quantity === '0'}
            helperText={errors.quantity ? 'Max 5 chars.' : ' '}
            onChange={onChangeHandler('quantity')}
          />
        </EditableField>
      </div>

      <div className={styles.tempWrapper}>
        <EditableField
          label='Serving Temperature'
          displayValue={servingTemperature}
          isEditing={isPricingEditing}
          showActions={false}
        >
          <SelectBox
            sx={{ width: '100%' }}
            label='Serving Temperature'
            value={servingTemperature}
            onChange={val => { setServingTemperature(val); trackField('serving_temperature', val) }}
            options={servingTemperatureList}
            helperText='Mandatory *'
          />
        </EditableField>
      </div>

    </div>
  </SectionCard>
  )
}
